import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AGENCY_OFFICERS_STORE_KEY } from './state/agency-officer-store.state';
import { AgencyOfficerDetailsEffects } from './state/agency-officer-store.effects';
import { AgencyOfficerDetailsReducer } from './state/agency-officer-store.reducer';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(AGENCY_OFFICERS_STORE_KEY, AgencyOfficerDetailsReducer), EffectsModule.forFeature([AgencyOfficerDetailsEffects])],
})
export class IntrensicAgencyManagementDataAccessModule {}
